import * as angular from "angular";

angular.module("ecanvasserControllers", [
    "navigation",
    "result",
    "filter",
    "activity",
    "vcHelper",
    "survey",
    "building",
    "consentType",
    "canvass",
    "campaignplan",
    "checklist",
    "canvassStatus",
    "canvasserTracking",
    "issue",
    "limit",
    "cancel",
    "chart",
    "pageHeading",
    "division",
    "duplicates",
    "effort",
    "field",
    "feature",
    "customize",
    "helpText",
    "home",
    "invite",
    "dashboard",
    "dataset",
    "dummyData",
    "houseoccupant",
    "house",
    "event",
    "talkingPoint",
    "user",
    "userMap",
    "seats",
    "collectionpurpose",
    "campaign",
    "organisation",
    "organisationSettings",
    "organisationInvite",
    "organisationUser",
    "organisationUserMap",
    "nationBuilder",
    "customField",
    "document",
    "people",
    "product",
    "permission",
    "prospector",
    "map",
    "team",
    "profile",
    "voterFile",
    "export",
    "street",
    "subscription",
    "essentials",
    "dataRecord",
    "integration",
    "privacy",
    "requestAccess",
    "general",
    "logs",
    "publicApi",
    "table",
    "signature",
    "permissionLevel",
    "planner",
    "conversionRateConfig",
    "qrCode",
]);
